import { Component } from '@angular/core';
import {ModalController, NavController, NavParams} from 'ionic-angular';

import { ProfilePage } from '../profile/profile';
import { SearchPage } from '../search/search';


@Component({
  selector: 'page-jobs',
  templateUrl: 'jobs.html',
})
export class JobsPage {

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private modalCtrl: ModalController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad JobsPage');
  }

  goToProfile() {
    this.modalCtrl.create(ProfilePage, {}).present().then(() => {});

  }

  goToSearch() {
    this.navCtrl.push(SearchPage, {})
      .then(() => {
        console.log('Welcome to search');
      })
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/jobs/jobs.ts